import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Typography,
  Divider,
  Menu,
  MenuItem,
} from "@mui/material";
import { NavLink, useLocation } from "react-router-dom"; // Import useLocation
import { useAuth0 } from "@auth0/auth0-react"; // Import the Auth0 hook

const NavBar = () => {
  const { logout, getAccessTokenSilently } = useAuth0(); // Get the logout function from Auth0
  const [anchorEl, setAnchorEl] = useState(null); // State for menu anchor
  const location = useLocation(); // Get the current route

  const openBullBoard = async () => {
    try {
      const token = await getAccessTokenSilently(); // Get the Auth0 token
      const bullBoardUrl = `/admin/queues?token=${token}`; // Append the token as a query param
      window.open(bullBoardUrl, "_blank");
    } catch (error) {
      console.error("Error getting access token:", error);
    }
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget); // Set the anchor element for the menu
  };

  const handleMenuClose = () => {
    setAnchorEl(null); // Close the menu
  };

  const isTasksRouteActive =
    location.pathname === "/tasksActivations" ||
    location.pathname === "/tasksMdnChange"; // Check if any Tasks menu route is active

  return (
    <AppBar
      position="static"
      sx={{ backgroundColor: (theme) => theme.palette.primary.dark }}
    >
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          Boom-Activation
          <Divider
            variant="fullWidth"
            sx={{
              borderTop: "1px solid pink", // Add thickness to the top border
            }}
          />
          {/* create button for admin queues */}
          <Button
            color="inherit"
            onClick={openBullBoard}
            sx={{
              textDecoration: "none",
              color: "yellow",
            }}
          >
            Queues
          </Button>
        </Typography>

        <Button
          color="inherit"
          component={NavLink}
          to="/"
          sx={{
            textDecoration: "none",
            color: "white",
            "&.active": { color: "yellow" }, // Highlights when active
          }}
        >
          Home
        </Button>

        <Button
          color="inherit"
          component={NavLink}
          to="/upload"
          sx={{
            textDecoration: "none",
            color: "white",
            "&.active": { color: "yellow" }, // Highlights when active
          }}
        >
          Upload
        </Button>

        {/* Tasks menu */}
        <Button
          color="inherit"
          onClick={handleMenuOpen}
          sx={{
            textDecoration: "none",
            color: isTasksRouteActive ? "yellow" : "white", // Change to yellow if any Tasks menu route is active
          }}
        >
          Tasks
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          sx={{
            "& .MuiMenu-paper": {
              backgroundColor: (theme) => theme.palette.primary.main, // Matches AppBar color
            },
          }}
        >
          <MenuItem
            component={NavLink}
            to="/tasksActivations" // Updated route for Activations
            onClick={handleMenuClose}
            sx={{
              "&.active": { color: "yellow" }, // Matches AppBar color when active
              color: "white", // Ensures text color is white
            }}
          >
            Activate Numbers
          </MenuItem>

          <MenuItem
            component={NavLink}
            to="/tasksMdnChange" // Updated route for Activations
            onClick={handleMenuClose}
            sx={{
              "&.active": { color: "yellow" }, // Matches AppBar color when active
              color: "white", // Ensures text color is white
            }}
          >
            Change Numbers
          </MenuItem>

          <MenuItem
            component={NavLink}
            to="/single-mdn-change"
            onClick={handleMenuClose}
            sx={{
              color: "white",
              "&.active": { color: "yellow" },
            }}
          >
            Single MDN Change
          </MenuItem>
        </Menu>

        {/* Logout button */}
        <Button
          color="inherit"
          onClick={() =>
            logout({
              returnTo: window.location.origin, // Redirect to home or login page based on your needs
            })
          }
          sx={{
            textDecoration: "none",
            color: "white",
          }}
        >
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
